export default "__VITE_ASSET__BQE$6Au$__"